// FILE: client/src/pages/Privacy.js

export default function Privacy() {
  return (
    <div style={{ maxWidth: 900, margin: "40px auto", padding: "0 16px", color: "white" }}>
      <h1>Privacy Policy</h1>
      <p>Effective Date: January 2026</p>

      <div
        style={{
          marginTop: "24px",
          marginBottom: "32px",
          padding: "16px 20px",
          borderRadius: "12px",
          background: "rgba(124,58,237,0.15)",
          border: "1px solid rgba(124,58,237,0.35)",
        }}
      >
        <p style={{ fontSize: "18px", fontWeight: "600", margin: 0 }}>
          We believe in private shared moments.
        </p>
        <p style={{ fontSize: "16px", opacity: 0.9, marginTop: "8px", marginBottom: 0 }}>
          We don’t sell your data. Ever.
        </p>
      </div>

      <h2>1. Information We Collect</h2>
      <p>
        We may collect limited information such as usernames entered in rooms, IP addresses, device information,
        temporary chat messages, and anonymized analytics data if enabled in the future.
      </p>

      <h2>2. Chat Data</h2>
      <p>
        Chat messages may be temporarily stored to improve service quality, security, and moderation.
        We do not sell or share chat data.
      </p>

      <h2>3. Analytics</h2>
      <p>
        We may use privacy-friendly analytics tools to understand how the service is used. These tools collect anonymized usage data only.
      </p>

      <h2>4. Data Sharing</h2>
      <p>
        We do not sell personal data. We only share information if required by law.
      </p>

      <h2>5. Children’s Privacy</h2>
      <p>
        WatchParty Rooms is intended for users 13 years and older. We do not knowingly collect data from children under 13.
      </p>

      <h2>6. Security</h2>
      <p>
        We take reasonable steps to protect your data, but no system is 100% secure.
      </p>

      <h2>7. Changes</h2>
      <p>
        This policy may be updated. Continued use means acceptance of the updated policy.
      </p>

      <h2>8. Contact</h2>
      <p>Email: watchpartyrooms@gmail.com</p>
    </div>
  );
}
